
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XButton,
XHeader
},
name: 'noCount',
data () {
return {

}
},
created() {

},
methods:{
relogin() {
localStorage.removeItem('loginData');
this.$router.push({
path: '/'
});
}
}
}



// WEBPACK FOOTER //
// ./src/pages/noCountData.vue